import { Classes, NonIdealState, Spinner } from '@blueprintjs/core'
import React, { SFC } from 'react'
import './spinner-loader.scss'

export const SpinnerLoader: SFC = () => (
  <NonIdealState className="spinner-loader anim--fade-in">
    <Spinner className={Classes.LARGE} />
  </NonIdealState>
)



// WEBPACK FOOTER //
// ./src/app/shared/components/spinner-loader/spinner-loader.component.tsx